"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSegmentId = exports.storeSegmentId = void 0;
/**
 * Returns a promise that resolves with the ID saved to LD localStorage.
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {Promise<void>} promise resolved response saved to LD localStorage
 */
const storeSegmentId = async (payloadCallback) => {
    return (0, exports.getSegmentId)().then((id) => {
        if (typeof id != "string")
            return;
        payloadCallback["_segment-clientID"] = id;
    });
};
exports.storeSegmentId = storeSegmentId;
/**
 * Checks if Segment library is loaded and ready to use.
 * If it is, it fetches anonymous ID from Segment.
 * @returns {Promise<unknown>} Segment anonymous ID
 */
const getSegmentId = async () => {
    if (typeof window === "undefined")
        return;
    return new Promise((resolve, reject) => {
        try {
            if (window && !window.analytics) {
                return reject(new Error("Segment library not loaded"));
            }
            window.analytics.ready(() => {
                resolve(window.analytics.user().anonymousId());
            });
        }
        catch (e) {
            reject(e);
        }
    });
};
exports.getSegmentId = getSegmentId;
